import { Announcement } from '@types';
import { convertDateAndTimeToDisplayFormat } from '@utils';

import styles from './announcementItem.module.scss';

export interface AnnouncementItemProps {
	announcement: Announcement;
}

export const AnnouncementItem = ({ announcement }: AnnouncementItemProps) => {
	const {
		authorisationReference,
		waterYear,
		allocationPercentage,
		authorisationVolume,
		maxVolume,
		effectiveDate,
		statusReason,
	} = announcement;
	return (
		<tr className={styles.container} role="row">
			<td className={styles['columns_centered']} role="rowheader" data-testid="waterYear">
				{waterYear}
			</td>
			<td className={styles['columns_numeric']}>
				{allocationPercentage.toLocaleString('en-AU', {
					maximumFractionDigits: 2,
					minimumFractionDigits: 2,
				})}
			</td>
			<td className={styles['columns_centered']} data-testid="effectiveDate">
				{convertDateAndTimeToDisplayFormat(effectiveDate)}
			</td>
			<td>{authorisationReference}</td>
			<td className={styles['columns_numeric']}>
				{authorisationVolume.toLocaleString('en-AU', {
					maximumFractionDigits: 2,
					minimumFractionDigits: 2,
				})}
				ML
			</td>
			<td className={styles['columns_numeric']}>
				{maxVolume.toLocaleString('en-AU', {
					maximumFractionDigits: 2,
					minimumFractionDigits: 2,
				})}
				ML
			</td>
			<td>{statusReason}</td>
		</tr>
	);
};
